module.exports = __webpack_public_path__ + "static/media/loc3_img5.2ad3b431.jpg";